// ─── Spinner — el anillo del diseño (I-244) ───────────────────────────────────
// `handoff_claude_ingresos_vestido/casa-estados.jsx:38-40` (y `casa-piezas-base`): un anillo de 2px en el color
// recibido, el cuarto de arriba transparente, 12px por defecto, vuelta cada .7s. Sale del tema, no de un índigo fijo.
import React from 'react';
import type { SpinnerSize, SpinnerColor } from '@/types';
import { useTema, type CasaTema } from '@components/M02/casaTema';

interface SpinnerProps {
  /** Píxeles. Los nombres `sm|md|lg` siguen valiendo (alias de 16|24|40) — 95 usos los escriben. */
  size?: SpinnerSize | number;
  /** Un nombre del tema (`white|blue|gray`, alias de los de siempre) o el color ya resuelto por quien lo llama. Sin nada: `fg2`, el de `casa-estados.jsx`. */
  color?: SpinnerColor | (string & Record<never, never>);
  className?: string;
}

const SIZE_MAP: Record<SpinnerSize, number> = { sm: 16, md: 24, lg: 40 };

// `blue` (el índigo de antes) ahora es el acento del tema; `gray` es el `fg3`; `white` el texto de un botón fuerte.
const COLOR_MAP: Record<SpinnerColor, (T: CasaTema) => string> = {
  white: (T) => T.btnFg,
  blue:  (T) => T.accent,
  gray:  (T) => T.fg3,
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 12, color, className }) => {
  const T = useTema();
  const px = typeof size === 'number' ? size : SIZE_MAP[size];
  const borde = color === undefined ? T.fg2 : color in COLOR_MAP ? COLOR_MAP[color as SpinnerColor](T) : color;

  return (
    <span
      role="img"
      aria-label="Cargando"
      className={className}
      style={{
        width: px, height: px, borderRadius: '50%', boxSizing: 'border-box', flexShrink: 0,
        border: `2px solid ${borde}`, borderTopColor: 'transparent',
        display: 'inline-block', animation: 'spin .7s linear infinite',
      }}
    />
  );
};

export default Spinner;
